export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Кіру:"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Жалғастыру"])}
}